export interface IConfig {
  serviceBaseUrl: string;
}

export const config: IConfig = {
  serviceBaseUrl: "<@SERVICE_BASE_URL@>",
};
